import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Stack } from '@mui/material';

import Footer from 'components/Footer';
import Header from 'components/Header';

import { ampli } from 'services/ampli';
import { useAppData, useUserStore } from 'providers/RootStoreProvider';
import useScrollEvent from 'hooks/useScrollEvent';
import checkAbTest from 'helpers/checkAbTest';

import css from './Main.module.css';
import { AppRoutes } from 'enums/routes.enum';
import { HomeVariants } from './variants/variants.const';
import { observer } from 'mobx-react-lite';

interface LandingScreenShownData {
    abPricesIdMyPhIn?: boolean;
    abPricesSgJpTh?: boolean;
    abApplepay?: boolean;
    isLandingTest?: boolean;
}

const Main = observer(() => {
    const [landingScreenAbProperties, setLandingScreenAbProperties] = useState<LandingScreenShownData | null>(null);
    const navigate = useNavigate();
    const { user } = useUserStore();
    const isLoggedIn = !!user?.email;
    const [searchParams] = useSearchParams();
    const usidParam = searchParams.get('usid');
    const gclid = localStorage.getItem('gclid');
    const abLandingEventSent = sessionStorage.getItem('abLandingEventSent');
    const { flowOuter, isAttributionSent } = useAppData();

    useScrollEvent(() => {
        if (ampli.isLoaded && isAttributionSent) {
            ampli.landingScroll();
        }
    });

    useEffect(() => {
        if (ampli.isLoaded && landingScreenAbProperties && isAttributionSent) {
            const params = {
                ab_price_ID_MY_PH_IN_2024_06_07: landingScreenAbProperties?.abPricesIdMyPhIn ? '1' : '0',
                ab_price_SG_JP_TH_2024_06_07: landingScreenAbProperties?.abPricesSgJpTh ? '1' : '0',
                ab_landing_2024_06_07: landingScreenAbProperties?.isLandingTest ? '1' : '0',
                ab_applepay_2024_08_14: landingScreenAbProperties?.abApplepay ? '1' : '0',
            };
            if (!abLandingEventSent) {
                ampli.landingScreenShown(params);
                sessionStorage.setItem('abLandingEventSent', '1');
            } else {
                ampli.landingScreenShown();
            }
        }
    }, [landingScreenAbProperties, isAttributionSent]);

    useEffect(() => {
        if (ampli.isLoaded && gclid && usidParam && isAttributionSent) {
            ampli.collectGclidForTest({ gclid: gclid });
        }

        if (usidParam) {
            setLandingScreenAbProperties({
                abPricesIdMyPhIn: checkAbTest('abPriceIdMyPhIn', true),
                abPricesSgJpTh: checkAbTest('abPriceSgJpTh', true),
                abApplepay: checkAbTest('abApplepay20240814', true),
            });
        }
    }, [usidParam]);

    useEffect(() => {
        if (isLoggedIn) {
            setTimeout(() => {
                navigate(AppRoutes.ACCOUNT);
            }, 500);
        }
    }, [isLoggedIn]);

    return (
        <Stack className={flowOuter ? css.main : ''} sx={{ width: '100%' }} direction={'column'}>
            <Header />
            {flowOuter ? <HomeVariants.with_faqs /> : <HomeVariants.base />}
            <Footer />
        </Stack>
    );
});

export default Main;
